import { Icon, Stack, Tabs } from '@efast_public/fjd-component-library';
import useTabs from '../../shared/hooks/useTabs';
import './SchreibtischTabbar.css';
import { RoutePaths } from '../../pages/AppRoutes';

export function SchreibtischTabbar() {
  const isOnSchreibtisch = document.location.pathname.includes(
    RoutePaths.SCHREIBTISCH
  );
  const { tabs, selectedTab, openTab, handleTabClose } = useTabs();

  if (!isOnSchreibtisch) return null;

  return (
    <Tabs index={selectedTab}>
      <Tabs.Bar>
        {tabs.map((tab, index) => (
          <Tabs.Tab
            iconVariant={tab.iconAppearance}
            icon={tab.icon}
            label={tab.label || 'Untitled'}
            key={tab.id}
            canClose
            onClick={() => openTab(tab.data.element)}
            onClose={() => handleTabClose(index)}
          />
        ))}
      </Tabs.Bar>
    </Tabs>
  );
}
